import { endpoint } from "../config/endpoint";
import axios from "axios";

const API_BASE = endpoint;

/**
 * Track views for videos
 * @param {string} videoId - The video ID
 * @returns {Promise}
 */
export const trackVideoView = async (videoId) => {
  try {
    const response = await axios.post(
      `${API_BASE}/v1/video/view-video/${videoId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error tracking video view:", error);
    throw error;
  }
};

/**
 * Track views for blogs
 * @param {string} blogId - The blog ID
 * @returns {Promise}
 */
export const trackBlogView = async (blogId) => {
  try {
    const response = await axios.post(
      `${API_BASE}/v1/blog/view-blog/${blogId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error tracking blog view:", error);
    throw error;
  }
};

/**
 * Track views for music
 * @param {string} musicId - The music ID
 * @returns {Promise}
 */
export const trackMusicView = async (musicId) => {
  try {
    const response = await axios.post(
      `${API_BASE}/v1/music/view-music/${musicId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error tracking music view:", error);
    throw error;
  }
};

/**
 * Track views for audio
 * @param {string} audioId - The audio ID
 * @returns {Promise}
 */
export const trackAudioView = async (audioId) => {
  try {
    const response = await axios.post(
      `${API_BASE}/v1/audio/view-audio/${audioId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error tracking audio view:", error);
    throw error;
  }
};

/**
 * Track views for influasity
 * @param {string} influasityId - The influasity ID
 * @returns {Promise}
 */
export const trackInfluasityView = async (influasityId) => {
  try {
    const response = await axios.post(
      `${API_BASE}/v1/influasity/view-influasity/${influasityId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error tracking influasity view:", error);
    throw error;
  }
};

/**
 * Get overall admin dashboard analytics
 * @param {string} token - Authentication token
 * @returns {Promise}
 */
export const getAnalyticsDashboard = async (token) => {
  try {
    const response = await axios.get(
      `${API_BASE}/v1/admin/analytics/dashboard`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching analytics dashboard:", error);
    throw error;
  }
};

/**
 * Get content-specific analytics with pagination
 * @param {string} type - Content type: 'video', 'blog', 'music', or 'audio'
 * @param {number} page - Page number (default: 1)
 * @param {number} pageSize - Items per page (default: 20)
 * @param {string} token - Authentication token
 * @returns {Promise}
 */
export const getContentAnalytics = async (type, page = 1, pageSize = 20, token) => {
  try {
    const response = await axios.get(
      `${API_BASE}/v1/admin/analytics/${type}`,
      {
        params: {
          page,
          pageSize,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(`Error fetching ${type} analytics:`, error);
    throw error;
  }
};
